/**
 * 商城我的页面 消息、代办、公告跳转类型
 * */
const MESSAGE_TYPE = {
  NOTICE: 0, // 消息
  ANNOUNCEMENT: 1, // 公告
  TODO: 2, // 待办
};

export { MESSAGE_TYPE };
